import type { ArticleRow } from '../../../api/visitorsDesk'
import { whoParts } from '../../../lib/deskArticles'
import { fmtInt } from '../../../lib/format'

export function Loading() { return <div className="h-24 bg-ink-800 animate-pulse" /> }
export function Failed({ what }: { what: string }) { return <p className="font-mono text-[12px] text-radar-red">Couldn’t load {what}</p> }

/** Legend for the who-read-it bars: anonymous, known, members. */
export function WhoLegend() {
  const parts = whoParts({ anonymous: 0, known: 0, member: 0 })
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1 text-[12px] text-paper-dim">
      {parts.map((p) => <span key={p.key}><span aria-hidden="true" style={{ color: p.color }}>■</span> {p.label}</span>)}
    </div>
  )
}

/** One thin split bar: anonymous, known, member. Counts are in the title and the label. */
export function WhoBar({ who }: { who: ArticleRow['who'] }) {
  const parts = whoParts(who)
  const total = parts.reduce((a, p) => a + p.value, 0)
  const text = parts.map((p) => `${p.label} ${fmtInt(p.value)}`).join(', ')
  return (
    <div role="img" aria-label={`Who read it: ${text}`} title={text} className="flex h-2.5 min-w-[110px] overflow-hidden bg-ink-600">
      {total > 0 && parts.map((p) => <span key={p.key} style={{ width: `${(p.value / total) * 100}%`, background: p.color }} />)}
    </div>
  )
}
